export const PLACE_ORDER_CHECKOUT = "PLACE_ORDER_CHECKOUT"
export const PLACE_ORDER_CHECKOUT_SUCCESSFUL = "PLACE_ORDER_CHECKOUT_SUCCESSFUL"
export const PLACE_ORDER_CHECKOUT_FAILED = "PLACE_ORDER_CHECKOUT_FAILED"
